<template>
  <div style="position: relative; width: 100%; height:100vh;">

    <div v-if="liveUrl" style="width: 100%; height: 60vh;  position: relative; ">
      <video autoplay v-if="liveUrl" style="width: 100%; height: 100%; " id="videoPlayer" ref="videoPlayer"
             x-webkit-airplay="true"
             webkit-playsinline="true" object-fit="cover"></video>
    </div>
    <div class="voice-chat-container" style="width:100%;  position: absolute; top: 0; left: 0;">
      <!-- 文字显示区域 -->
      <div class="text-display" @click="clickScreen" style="width: 100%">
        <div v-if="isSpeaking && !liveUrl" style="padding: 30px; text-align: left; width: 90%" v-html="text"></div>
        <div v-if="!isSpeaking && !liveUrl" style="padding: 30px; text-align: left; width: 90%; max-height: 400px; " v-html="notify_text"></div>
      </div>

      <!-- 状态区 -->
      <div  class="status-area" @click="clickScreen">
        <!-- 状态信息可以在这里显示 -->
        <!--      <div v-if="!isSpeaking"><img src="@/assets/icon/playing.gif" width="150px" height="150px"/></div>-->
        <div v-if="!liveUrl" style="font-size: 14px; color: darkgray">{{ status }}</div>
      </div>

      <!-- 控制区 -->

      <div class="control-area">
        <!--        <el-button v-if="!isMuted" size="large" type="text" @click="toggleMute">关闭麦克风</el-button>-->
        <!--        <el-button v-if="isMuted" size="large" type="text" @click="toggleMute">打开麦克风</el-button>-->

        <div>
          <img v-if="!isMuted" src="@/assets/icon/micro.png" width="40px" height="40px" style=""
               @click="toggleMute"/>
          <img v-if="isMuted" src="@/assets/icon/micro_forbid.png" width="40px" height="40px" style=""
               @click="toggleMute"/>
          <div style="text-align: center; color: darkgray; font-size: 12px; margin-top: 5px">
            {{ !isMuted ? '已打开' : '已关闭' }}
          </div>
        </div>


        <div v-if="!isStart" @click="startChat"><img src="@/assets/icon/start.png" width="100px" height="100px"/></div>
        <div v-if="isStart" @click="stopChat"><img src="@/assets/icon/stop.png" width="100px" height="100px"/></div>

        <div>
          <img v-if="isSpeakerOn" src="@/assets/icon/volume.png" width="40px" height="40px" style=""
               @click="toggleSpeaker"/>
          <img v-if="!isSpeakerOn" src="@/assets/icon/volume_forbid.png" width="40px" height="40px" style=""
               @click="toggleSpeaker"/>
          <div style="text-align: center; color: darkgray; font-size: 12px; margin-top: 5px">
            {{ isSpeakerOn ? '已打开' : '已关闭' }}
          </div>
        </div>

        <!--        <el-button v-if="isSpeakerOn" size="large" type="text" @click="toggleSpeaker">关闭扬声器</el-button>-->
        <!--        <el-button v-if="!isSpeakerOn" size="large" type="text" @click="toggleSpeaker">打开扬声器</el-button>-->
      </div>

    </div>
  </div>

</template>

<script>

import AliRtcEngine from 'aliyun-rtc-sdk';

const aliRtcEngine = AliRtcEngine.getInstance();
import {AliRTS} from 'aliyun-rts-sdk';

export default {
  name: 'VoiceChatView',

  data() {
    return {

      text: '',
      isTextEnd: true,
      notify_text: '',
      isNotifyEnd: true,
      status: '',
      isMuted: false,
      isSpeakerOn: true,
      isStart: false,
      agentItemId: '',
      isSpeaking: false,
      instance: '',
      socket: null,
      statusText: "你可以直接讲话或者点击屏幕打断我",

      aliRts: null,
      liveUrl: '',
    };
  },
  beforeDestroy() {
    this.stopChat();
  },
  methods: {
    init(agentItemId) {
      this.agentItemId = agentItemId
      this.liveUrl = ''
      this.initEngin()
      this.text = ""
      this.notify_text = ""
      //this.getAgentInfo()
    },
    getAgentInfo: function () {
      let that = this;
      this.$post(
        {
          context: that,
          path: '/agent/info/',
          params: {
            item_id: this.agentItemId
          },
          success: function (data) {
            that.agent = data.agent;
          }
        }
      )
    },

    initWebSocket() {
      //this.socket = new WebSocket('ws://localhost:55001/interview_socket');
      this.socket = new WebSocket(this.$chatHost.replace('https://', 'wss://') + '/rtc_socket');

      this.socket.onopen = () => {
        console.log('WebSocket 连接已打开');
        //需要鉴权
        const message = {type: 'login', id: this.instance};
        console.log('发送消息: ' + message)
        this.socket.send(JSON.stringify(message));
      };

      this.socket.onmessage = (event) => {
        console.log('收到消息:', event.data);
        const data = JSON.parse(event.data);
        if (data.type === 'system_subtitle') {

          const text = data.text.replaceAll('\n', '<br/>')

          if (data.end) {
            this.isNotifyEnd = true;
            this.status = this.statusText;
          } else {
            if (this.isNotifyEnd) {
              this.notify_text = "";
            }
            this.notify_text = this.notify_text + text;
            this.isNotifyEnd = false;
          }


        } else if (data.type === 'user_subtitle') {
          const text = data.text.replaceAll('\n', '<br/>')
          if (data.end) {
            this.isTextEnd = true;
            this.isSpeaking = false
          } else {
            if (this.isTextEnd) {
              this.text = "";
              this.notify_text = "";
            }
            this.text = this.text + text;
            this.isTextEnd = false;
            this.isSpeaking = true
          }

        }
      };

      this.socket.onerror = (error) => {
        console.error('WebSocket 错误:', error);
      };

      this.socket.onclose = () => {
        console.log('WebSocket 连接已关闭');
      };
    },


    initEngin() {

      aliRtcEngine.setChannelProfile('communication');
      aliRtcEngine.setClientRole('interactive');
      aliRtcEngine.enableLocalVideo(false);
      aliRtcEngine.publishLocalVideoStream(false);
      aliRtcEngine.setDefaultSubscribeAllRemoteVideoStreams(false);
      console.log('本地视频设置未打开')

      aliRtcEngine.publishLocalAudioStream(true);
      aliRtcEngine.setDefaultSubscribeAllRemoteAudioStreams(true);


      aliRtcEngine.on('bye', (code) => {
        // code 为原因码，具体含义请查看 API 文档
        console.log(`bye, code=${code}`);
        // 这里做您的处理业务，如退出通话页面等
        this.stopChat()
      });

      // 监听远端用户上线
      aliRtcEngine.on('remoteUserOnLineNotify', (userId, elapsed) => {
        console.log(`用户 ${userId} 加入频道，耗时 ${elapsed} 秒`);
        // 这里处理您的业务逻辑，如展示这个用户的模块
        if (userId.includes('robot')) {
          // this.play(1)
        }
      });

      // 监听远端用户下线
      aliRtcEngine.on('remoteUserOffLineNotify', (userId, reason) => {
        // reason 为原因码，具体含义请查看 API 文档
        console.log(`用户 ${userId} 离开频道，原因码: ${reason}`);
        // 这里处理您的业务逻辑，如销毁这个用户的模块
        this.stopChat()
      });

      // 监听远端流订阅变化
      aliRtcEngine.on('videoSubscribeStateChanged', (userId, oldState, newState, interval, channelId) => {
        // oldState、newState 类型均为AliRtcSubscribeState，值包含 0（初始化）、1（未订阅）、2（订阅中）、3（已订阅）
        // interval 为两个状态之间的变化时间间隔，单位毫秒
        console.log(`频道 ${channelId} 远端用户 ${userId} 订阅状态由 ${oldState} 变为 ${newState}`);
        // 这里处理观看远端流的逻辑
        // 当 newState 变为 3 时可以通过 setRemoteViewConfig 播放远端流
        // 当 newState 变为 1 时可以停止播放
      });

      // 监听鉴权信息过期
      aliRtcEngine.on('authInfoExpired', () => {
        // 该回调触发代表鉴权信息已过期
        // 需要重新获取 token 等数据，调用 refreshAuthInfo 接口更新鉴权数据
      });

      // 监听用户鉴权信息即将过期
      aliRtcEngine.on('authInfoWillExpire', () => {
        // 该回调在鉴权信息30秒前触发，收到该回调后应该及时更新鉴权信息
        // 若想要继续在会中，需要重新获取 token 等数据，调用 joinChannel 重新入会
      });


    },

    stopChat() {
      if (!this.isStart) {
        return
      }
      this.socket.close();

      aliRtcEngine.stopPreview();
      aliRtcEngine.leaveChannel();
      aliRtcEngine.destroy();

      if (this.liveUrl) {
        this.$refs.videoPlayer.pause();
      }
      this.isStart = false
      this.$emit('stop')
    },

    clickScreen() {
      //engine.interruptSpeaking()
      const message = {type: 'interrupt', id: this.instance};
      console.log('发送消息: ' + message)
      this.socket.send(JSON.stringify(message));
    },

    startChat() {
      let token = localStorage.getItem("token");
      if (!token) {
        console.log('未登陆')
        this.$emit("checkLogin");
        return;
      }

      let t = this;
      this.$post(
        {
          context: t,
          loading: true,
          path: '/aigc/voice/agent/start/',
          params: {
            item_id: this.agentItemId || ''
          },
          success: function (data) {
            console.log(data);
            t.liveUrl = data.liveUrl
            t.instance = data.instance
            t.initWebSocket()
            aliRtcEngine.joinChannel(data.info, data.username);

            t.status = this.statusText;
            t.isStart = true

            if (t.liveUrl) {
              t.$nextTick(() => {
                t.startLive()
              })
            }

          }
        }
      );
    },


    startLive() {
      if (!this.liveUrl) {
        return
      }


      const video = this.$refs.videoPlayer;
      this.aliRts = AliRTS.createClient();
      if (video) {
        video.muted = false;
      }
      this.aliRts.subscribe(this.liveUrl).then((remoteStream) => {
        console.log('开始播放 ' + this.liveUrl)
        remoteStream.play(video);
      }).catch((err) => {
        console.log(err)
      })

    },
    toggleMute() {
      this.isMuted = !this.isMuted;
      //engine.mute(this.isMuted);
      aliRtcEngine.muteLocalMic(this.isMuted);
      this.text = this.isMuted ? "已静音" : "取消静音";
    },

    toggleSpeaker() {
      this.isSpeakerOn = !this.isSpeakerOn;
      //engine.setSpeaker(this.isSpeakerOn);
      aliRtcEngine.setAudioOutputEnabled(this.isSpeakerOn)
      this.text = this.isSpeakerOn ? "扬声器已开启" : "扬声器已关闭";
    }
  }
};
</script>

<style scoped>
.voice-chat-container {
}

.text-display {
  display: flex;
  flex-direction: column;
  /*justify-content: center;*/
  align-items: center;
  height: 50vh;
}

.status-area {
  display: flex;
  justify-content: center;
  align-items: center;
  color: black;
  height: 100px;
}

.control-area {
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 100px;
}


</style>
